/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useContext, useState } from 'react';
import { Row, Col, SegmentedController, SegmentedControllerPanel } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import style from './ShippingCallbackConfigurator.module.less';

interface Tab {
  label: string;
  tabId: string;
  id: string;
  sectionKey: string;
}

interface ShippingCallbackConfiguratorProps {
  codeBlockKey: string;
  content: {
    [key: string]: Tab[];
  };
}

interface KeyItem {
  label: string;
  enabled: boolean;
}

const ShippingCallbackConfigurator: React.FC<ShippingCallbackConfiguratorProps> = ({ content }) => {
  const {
    // @ts-expect-error
    code: { updateActiveCodeBlock, updateCurrentSectionKey },
    // @ts-expect-error
    ShippingCallbackConfigurator: { updateShippingCallbackSelection },
    // @ts-expect-error
    codeHighlight: { codeBlock, currentSectionKey }
  } = useContext(IntegrationPageSectionContext);
  const [selectedTabIdx, setSelectedTabIdx] = useState(0);

  const updateKeys = (keyList: KeyItem[]) => {
    const keysToActivate: string[] = [];
    const keysToDeactivate: string[] = [];

    keyList.map((key: KeyItem) => {
      if (key.enabled) {
        keysToActivate.push(key.label);
      } else {
        keysToDeactivate.push(key.label);
      }
    });

    updateActiveCodeBlock({ key: keysToDeactivate, value: false });
    updateActiveCodeBlock({ key: keysToActivate, value: true });
  };

  const getKeysForTab = (tabType: string) => {
    return tabType === 'server'
      ? [
          { label: 'shippingWrapper', enabled: false },
          { label: 'handleShippingAddress', enabled: false },
          { label: 'paymentSource', enabled: true },
          { label: 'serverSideShippingCallback', enabled: true },
          { label: 'callbackServer', enabled: true }
        ]
      : [
          { label: 'shippingWrapper', enabled: true },
          { label: 'handleShippingAddress', enabled: true },
          { label: 'paymentSource', enabled: false },
          { label: 'serverSideShippingCallback', enabled: false },
          { label: 'callbackServer', enabled: false }
        ];
  };
  const { tabs } = content;
  function handleTabClick(_e: React.MouseEvent<HTMLElement>, index: number) {
    updateShippingCallbackSelection(tabs[index].id);
    setSelectedTabIdx(index);

    if (tabs[index].id === 'server') {
      const codeBlocksToToggle = getKeysForTab('server');
      if (
        codeBlock?.key === 'shippingWrapper' &&
        currentSectionKey === 'iStandardFrontendShipping'
      ) {
        updateCurrentSectionKey(tabs[index].sectionKey);
        updateKeys(codeBlocksToToggle);
      }
    } else if (tabs[index].id === 'client') {
      const codeBlocksToToggle = getKeysForTab('client');
      if (
        codeBlock?.key === 'paymentSource' &&
        currentSectionKey === 'iStandardServerSideShipping'
      ) {
        updateCurrentSectionKey(tabs[index].sectionKey);
        updateKeys(codeBlocksToToggle);
      }
    }
  }

  return (
    <Row className={style.callback_tabs_wrapper}>
      <Col form="auto">
        <SegmentedController
          name="TabsGroup1"
          selectedTabIdx={selectedTabIdx}
          tabs={tabs.map((tab: Tab) => ({
            label: tab.label,
            panelId: tab.tabId,
            id: tab.id
          }))}
          onClick={(_e, index) => handleTabClick(_e, index as number)}
        >
          {tabs.map((tab: Tab) => (
            <SegmentedControllerPanel key={tab.id} tabId={tab.id} id={tab.tabId} />
          ))}
        </SegmentedController>
      </Col>
    </Row>
  );
};

export default ShippingCallbackConfigurator;
